import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { fetchEstates, searchEstates } from "../services/api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import "../styles/Estates.css";
import NotFound from "../components/NotFound";
import Pagination from "../components/Pagination";
import EstateCard from "../components/EstateCard";

const Estates = () => {
  const [estates, setEstates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [typingTimeout, setTypingTimeout] = useState(null);

  // Skeleton loader component
  const EstateSkeleton = () => (
    <div className="col-xl-4 col-md-6">
      <div className="estate-card">
        <div className="estate-img">
          <Skeleton height={250} />
        </div>
        <div className="estate-content">
          <h4 className="estate-title">
            <Skeleton width={200} />
          </h4>
          <Skeleton count={2} />
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    const getEstates = async () => {
      setLoading(true);
      try {
        const response = await fetchEstates(currentPage);
        if (response.success && response.payload) {
          setEstates(response.payload.page);
          setTotalPages(response.payload.totalPages);
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    getEstates();
  }, [currentPage]);

  const handleSearch = async (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    const timeout = setTimeout(async () => {
      if (!value.trim()) {
        const response = await fetchEstates(0);
        if (response.success && response.payload) {
          setEstates(response.payload.page);
        }
        return;
      }

      try {
        const results = await searchEstates(value);
        if (results.success && results.payload) {
          setEstates(results.payload.page);
        }
      } catch (error) {
        console.error("Search failed:", error);
      }
    }, 500);

    setTypingTimeout(timeout);
  };

  return (
    <>
      {/* <Header /> */}
      <div
        className="breadcumb-wrapper"
        style={{
          backgroundImage: "url('/assets/img/main/m1.jpeg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="container z-index-common">
          <div className="breadcumb-content">
            <h1 className="breadcumb-title">Our Estates</h1>
            <div className="breadcumb-menu-wrap">
              <ul className="breadcumb-menu">
                <li>
                  <Link to="/">Home</Link>
                </li>
                <li>Estates</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <section className="estate-section">
        <div className="container">
          <div className="row align-items-center mb-4">
            <div className="col-lg-6">
              <div className="title-area">
                <span className="sub-title6">OUR ESTATES</span>
                <h2 className="sec-title">Top Estates</h2>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="search-area">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search estates..."
                    value={searchTerm}
                    onChange={handleSearch}
                  />
                  {loading && (
                    <span
                      className="position-absolute"
                      style={{
                        right: "60px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        zIndex: 4,
                      }}
                    >
                      <span className="spinner-border spinner-border-sm text-primary" />
                    </span>
                  )}
                  <button
                    className="btn btn-primary"
                    style={{
                      background: "var(--theme-color)",
                      border: "none",
                      padding: "0 25px",
                    }}
                    disabled={loading}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            {loading ? (
              [...Array(6)].map((_, index) => <EstateSkeleton key={index} />)
            ) : estates.length === 0 ? (
              <NotFound message="No estates found" />
            ) : (
              estates.map((estate) => (
                <EstateCard key={estate.id} estate={estate} />
              ))
            )}
          </div>

          {!loading && estates.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={(page) => {
                setCurrentPage(page);
                window.scrollTo(0, 0);
              }}
            />
          )}
        </div>
      </section>
      {/* <Footer /> */}
    </>
  );
};

export default Estates;
